const updateObject = (oldObj, newParams) => ({ ...oldObj, ...newParams });

export default updateObject;
